/*!--------------------------------------------------------------------------
// <copyright file="GSS.portal.js" company="Gallup" product="GSS" owner="All">
//    Copyright (c) The Gallup Organization. All rights reserved.
// </copyright>
//--------------------------------------------------------------------------*/
/// <reference path="../../common/scripts/GSS.common.js" />
/// <reference path="GSS.portalContainer.js" />
var GSS = GSS || {};
GSS.portal = {
    urls: {
        logout: ''
    },
    errorContent: {
        content: ''
    },
    idleMonitor: {
        extendSessionTimer: 0,
        idleTime: 0,
        expirationFlagEnabled: false,
        sessionExpirationId: "sessionExpiration",
        pageActivityDetected: false,
        extendSessionMessage: "Your session is expiring. Click OK to extend your session.",
        settings: {
            timerIncrementInterval: 60000, // 1 minute in milliseconds
            idleTimeWarning: 25, // 25 minutes
            idleTimeLogout: 29, // 29 minutes
            extendTokenInterval: 5 // 5 minutes 
        },
        setup: function (description) {
            GSS.portal.idleMonitor.pageActivityDetected = false;
            GSS.portal.idleMonitor.extendSessionMessage = description;
        },
        initialize: function () {
            function getFeatureFlag() {
                // Get an initial expiration and token information
                return $.ajax({
                    type: "GET",
                    url: '../_Home/SessionExpirationEnabled',
                    cache: false,
                    contentType: "application/json",
                }).done(function (data) {
                    if (data.Enabled) {
                        // Getting the actual time for idleTimeLogout
                        // This will account for navigating away from the browser, etc.
                        GSS.portal.idleMonitor.settings.idleTimeLogout = Math.floor(new Date().getTime() / 1000) + 1800;
                        GSS.portal.idleMonitor.settings.timerIncrementInterval = 1000;
                        GSS.portal.idleMonitor.settings.extendTokenInterval = 3300; // 55 minutes in seconds
                    } else {
                        // Ensuring idleTimeLogout is default is the feature flag is off
                        GSS.portal.idleMonitor.settings.idleTimeLogout = 29;
                    }

                    GSS.portal.idleMonitor.expirationFlagEnabled = data.Enabled;
                    setInterval(GSS.portal.idleMonitor.process, GSS.portal.idleMonitor.settings.timerIncrementInterval);
                });
            }

            // Setting to a future value due to the discrepancy of seconds vs minutes on the old vs new popup before the FF is called
            GSS.portal.idleMonitor.settings.idleTimeLogout = Math.floor(new Date().getTime() / 1000) + 1800;

            // Token Response has the token as a field
            getFeatureFlag().then(function () {});

            $(document).on('click', GSS.portal.idleMonitor.registerPageActivity);
            $(document).on('keypress', GSS.portal.idleMonitor.registerPageActivity);
        },
        process: function () {
            if (GSS.portal.idleMonitor.expirationFlagEnabled) {
                const MINUTE = 60;
                const HOUR = 60 * MINUTE;

                function formatSeconds(seconds) {
                    if (seconds < 10) {
                        return "0" + seconds;
                    }

                    return seconds;
                }

                function createBackdrop(parentElement) {
                    const backdrop = document.createElement("div");
                    backdrop.className = "modal-backdrop fade in";
                    backdrop.id = "sessionExpirationBackdrop";

                    parentElement.prepend(backdrop);

                    if (!document.body.classList.contains("modal-open")) {
                        document.body.classList.add("modal-open");
                    }
                }

                // Check for page activity to see if a refresh is needed.
                if (GSS.portal.idleMonitor.pageActivityDetected) {
                    GSS.portal.idleMonitor.pageActivityDetected = false;
                    const expirationTime = window.localStorage.getItem("expiration") - 300;
                    const exprDiffTime = expirationTime - Math.floor(new Date().getTime() / 1000);
                    
                    if (!document.getElementById(GSS.portal.idleMonitor.sessionExpirationId)) {
                        const _session = new GSS.common.session(true);
                        const _sessionItem = _session.getItem("__client_user_data");

                        if (_sessionItem && _sessionItem.value) {

                            if (exprDiffTime <= 600) {
                                GSS.common.refreshTokenAsync();
                            }

                        }

                        GSS.portal.idleMonitor.resetTimer();
                    }
                }

                const wrapElement = document.getElementById("wrap");
                if (wrapElement) {
                    const logoutDiffTime = GSS.portal.idleMonitor.settings.idleTimeLogout - Math.floor(new Date().getTime() / 1000);
                    const expirationTime = window.localStorage.getItem("expiration") - 300;
                    const exprDiffTime = expirationTime - Math.floor(new Date().getTime() / 1000);

                    const diffTime = logoutDiffTime <  exprDiffTime ? logoutDiffTime : exprDiffTime;

                    if (diffTime <= 300 && !GSS.portal.idleMonitor.pageActivityDetected && window.localStorage.getItem("expiration")) {
                        const dialogElement = document.getElementById(GSS.portal.idleMonitor.sessionExpirationId);

                        if (!dialogElement) {
                            const dialog = document.createElement("dialog");
                            dialog.className = "c-well__no-border";
                            dialog.id = GSS.portal.idleMonitor.sessionExpirationId;
                            dialog.role = "alertDialog";

                            dialog.innerHTML =
                              "<div class='modal__dialog modal__dialog--md'>" +
                                "<div class='modal__content'>" +
                                    "<div class='modal-header'>" +
                                        "<div class='modal__title u-text-gray--6 u-fs-20 u-fw--700' tabindex='0'> Session Expiring " +
                                        "</div>" +
                                    "</div>" +
                                    "<div class='modal-body clearfix'>" +
                                        "<div class='u-py--0 u-mb--20'>" +
                                          "<p id='sessionExpirationBody'>" +
                                            GSS.portal.idleMonitor.extendSessionMessage +
                                          "</p>" +
                                        "</div>" +
                                        "<p class='text-right'>" +
                                            "<button class='btn btn-default' onClick='GSS.portal.idleMonitor.logout()'> Logout </button>" +
                                            "<button class='btn btn-primary' onClick='GSS.portal.idleMonitor.extendToken()'> Extend </button>" +
                                        "</p>" +
                                    "</div>" +
                                "</div>" +
                            "</div>";
                            
                            const openModals = document.querySelectorAll(".fade.in");
                            
                            if (openModals.length > 0) {
                                openModals[0].prepend(dialog);
                            } else {
                                wrapElement.prepend(dialog);
                                createBackdrop(wrapElement);
                            }

                            dialog.showModal();
                        } else if (dialogElement && !dialogElement.open) {
                            dialogElement.showModal();
                            createBackdrop(wrapElement);
                        }
                    }

                    const body = document.getElementById("sessionExpirationBody");
                    if (window.localStorage.getItem("expiration") && body && diffTime < GSS.portal.idleMonitor.settings.extendTokenInterval) {
                        var seconds = 0;
                        var minutes = 0;
                        var hours = 0;

                        // Manage the time otherwise if the session has expired, otherwise logout.
                        if (diffTime > 0) {
                            seconds = Math.floor((Math.abs(diffTime)) % 60);
                            minutes = Math.floor((Math.abs(diffTime) / MINUTE) % 60);
                            hours = Math.floor((Math.abs(diffTime) / HOUR) % 60);
                        } else {
                            GSS.portal.idleMonitor.logout();
                        }

                        body.innerHTML = GSS.portal.idleMonitor.extendSessionMessage + "<strong>" + " " + hours * 60 + minutes + ":" + formatSeconds(seconds) + "</strong>";
                    }
                }
            } else {
                GSS.portal.idleMonitor.extendSessionTimer = GSS.portal.idleMonitor.extendSessionTimer + 1;
                if (GSS.portal.idleMonitor.pageActivityDetected) {
                    if (GSS.portal.idleMonitor.extendSessionTimer >= GSS.portal.idleMonitor.settings.extendTokenInterval) {
                        GSS.PortalContainer.extendSession();
                        GSS.portal.idleMonitor.resetTimer();
                        GSS.portal.idleMonitor.pageActivityDetected = false;
                    }
                } else {
                    GSS.portal.idleMonitor.idleTime = GSS.portal.idleMonitor.idleTime + 1;
                    if (GSS.portal.idleMonitor.idleTime >= GSS.portal.idleMonitor.settings.idleTimeLogout) {
                        GSS.portal.idleMonitor.logout();
                    }

                    if (GSS.portal.idleMonitor.idleTime == GSS.portal.idleMonitor.settings.idleTimeWarning) {
                        if (window.confirm(GSS.portal.idleMonitor.extendSessionMessage)) {
                            if (typeof GSS.analytics !== 'undefined') {
                                GSS.analytics.event("button_click", { event_category: "session_alert", event_label: "OK" });
                            }

                            GSS.portal.idleMonitor.resetTimer();
                            GSS.PortalContainer.extendSession();
                        } else {
                            GSS.portal.idleMonitor.logout();
                        }
                    }
                }
            }
        },
        resetTimer: function () {
            if (GSS.portal.idleMonitor.expirationFlagEnabled) {
                GSS.portal.idleMonitor.settings.idleTimeLogout = Math.floor(new Date().getTime() / 1000) + 1800;
            }

            GSS.portal.idleMonitor.idleTime = 0;
            GSS.portal.idleMonitor.extendSessionTimer = 0;
        },
        registerPageActivity: function () {
            GSS.portal.idleMonitor.pageActivityDetected = true;
        },
        logout: function () {
            if (GSS.portal.idleMonitor.expirationFlagEnabled) {
                sessionStorage.removeItem("__client_user_data");
                window.localStorage.removeItem("expiration");
            }

            const signOut = document.getElementById("signOut");
            GSS.portal.idleMonitor.resetTimer();

            if (signOut && signOut.parentElement) {
                signOut.parentElement.submit();
            } else {
                GSS.portal.logout();
            }
            
        },
        closeModal: function() {
            GSS.portal.idleMonitor.pageActivityDetected = false;
            GSS.portal.idleMonitor.resetTimer();
            const backdrop = document.getElementById("sessionExpirationBackdrop");
            const dialog = document.getElementById(GSS.portal.idleMonitor.sessionExpirationId);

            // Checking for other open modals, and only removing backdrop 
            // and scroll bar disable if session expiration is the only modal open
            const openModals = document.querySelectorAll(".fade.in");

            if (document.body.classList.contains("modal-open") && openModals.length <= 1) {
                document.body.classList.remove("modal-open");
            }

            if (backdrop && openModals.length <= 1) {
                backdrop.remove();
            }

            if (dialog) {
                dialog.remove();
            }
        },
        extendToken: function() {
            GSS.portal.idleMonitor.closeModal();

            if (typeof GSS.analytics !== 'undefined') {
                GSS.analytics.event("button_click", { event_category: "session_alert", event_label: "OK" });
            }

            GSS.common.refreshTokenAsync();
        }
    },
    history: {
        enableHistory: false,
        initialLoad: null,
        activateHistory: function () {
            // <summary>Add event handlers for history.</summary>
            if (window.History.enabled) {
                GSS.portal.history.enableHistory = true;
                GSS.portal.history.initialLoad = true;
                window.History.Adapter.bind(window, 'statechange', GSS.PortalContainer.History.handleStateChangeEvent); // handles back button
                GSS.PortalContainer.History.replaceState(); // captures initial load of full app to store instance in history

                // TODO: Enable page refresh handler
                //$(window).on('beforeunload', GSS.PortalContainer.handleBeforeUnloadEvent); // handles page refresh
            }
        },
        activategssHistory: function () {
            if (window.History.enabled) {
                GSS.gssHistory.init();
            }
        }
    },
    changeClient: function (e, clientId) {
        // <summary>Changes the client in the url.</summary>
        // <param name="e">The event.</param>
        // <param name="clientId">The new client id value.</param>
        var _curClientId = $('[data-gss-clientid]').attr('data-gss-clientid');
        window.location.href = window.location.href.replace("gssClientId=" + _curClientId, "gssClientId=" + clientId);
  
    },
    logout: function (e) {
        // <summary>Logs the user out.</summary>
        var signOutOption = $('#signOut');
        if (signOutOption.val()) {
            signOutOption.trigger('click');
        }
    },
    modal: {
        size: {
            large: 'modal-lg',
            small: 'modal-sm',
        },
        wrap: function (contentDiv, size, onHiddenFunc) {
            // <summary>Wrap the modal window to the content div.</summary>
            // <param name="contentDiv">The content within a div</param>
            // <param name="size">The size of the modal window</param>
            // <param name="onHiddenFunc">The function is called after the window hides</param>

            // Set the size of the modal window
            var _size = size || GSS.portal.modal.size.large;

            // Wrap the content with modal divs
            $(contentDiv).wrap($('<div/>', {
                'id': GSS.PortalContainer.modalValues.container,
                'class': 'modal fade in',
                'tabindex': -1,
                'role': 'dialog',
                'aria-labelledby': GSS.PortalContainer.modalValues.container
            }))
                .wrap($('<div/>', { 'class': 'modal-dialog ' + _size }))
                .wrap($('<div/>', { 'class': 'modal-content' }));

            // Find the modal container and show the modal window
            var _modalContainer = $(contentDiv).closest('#' + GSS.PortalContainer.modalValues.container);
            _modalContainer.modal('show');

            // Add the onHiddenFunc to on hidden event
            $(_modalContainer).on('hidden.bs.modal', function () {
                $(contentDiv).unwrap().unwrap().unwrap();

                // If there is a onHiddenFunc defined, then call the onHiddenFunc,
                // otherwise just hide the content div
                if (onHiddenFunc) {
                    if (typeof (onHiddenFunc) === "function") {
                        onHiddenFunc();
                    }
                    else if (typeof (onHiddenFunc) === "string") {
                        GSS.common.getFunction(onHiddenFunc());
                    }
                } else {
                    if ($(contentDiv).is('.show')) {
                        $(contentDiv).removeClass('show').addClass('hidden').hide();
                    }
                }
            });

            return contentDiv;
        },
        unWrap: function (contentDiv) {
            // <summary>Hide the modal window of the content div.</summary>
            // <param name="contentDiv">The content within a div wrapped with modal window</param>
            var _modalContainer = $(contentDiv).closest('#' + GSS.PortalContainer.modalValues.container);
            _modalContainer.modal('hide');
        },
    },
    setupTileResponsiveness: function (document, $, enquire) {
        "use strict";
        // <summary>Sets up logic for tile resizing on different viewports.</summary>
        // <param name="document">Global document scope.</param>
        // <param name="$">jQuery instance</param>
        // <param name="enquire">enquire instance</param>
        var tiles = document.querySelectorAll("#dashtile-container > .gss-tile");
        if (!tiles.length) {
            return;
        }

        var row = [];
        var rowLength = 0; // Current total width of tiles in the row
        var rowLarge = 0; // The number of rows that are reduced due to a tall tile

        for (var i = 0; i < tiles.length; i++) {
            var tile = tiles[i];
            var height = parseInt(tile.getAttribute("data-gss-widget-height"));
            var width = parseInt(tile.getAttribute("data-gss-widget-width"));
            // Put the tiles into rows based on their width and a max per row of 3
            // TODO: Support for half sizes?
            rowLength += width;

            // Store the original tile size
            $(tile).addClass("gss-tile-x" + (width * 10));
            // All tiles are sized 10 when in 1 column mode
            tile.setAttribute("data-tile-x-sm", 10);
            // Until we know otherwise, set 2 and 3 col modes to default configured sized
            tile.setAttribute("data-tile-x-md", (Math.min(2, width) * 10));
            tile.setAttribute("data-tile-x-default", (width * 10));

            // Add the tile to this row if there is room for it
            if (rowLength + rowLarge <= 3) {
                row.push(tile);

                // The next row spaces should be reduced by tall tiles
                if (height > 1) {
                    rowLarge += height;
                }
            } else {
                // There's no more room - do the existing items need to stretch?
                if (row.length === 1) {
                    // We have no room after one tile? What do we do about that?
                } else if (row.length === 2) {
                    for (var j = 0; j < row.length; j++) {
                        var t = row[j];
                        var tw = parseInt(t.getAttribute("data-gss-widget-width"));
                        // one of the items is 2 wide by default, make it 1 in medium view
                        if (tw == 2) {
                            t.setAttribute("data-tile-x-sm", 10);
                        }
                        if (j === 1 && tw === 1) {
                            // If we don't want to leave a gap, we could do this:
                            // We have two tiles only on this row, make this one double-width on desktop
                            //t.setAttribute("data-tile-x-default", 20);
                        }
                    }
                } else if (row.length === 3) {
                    // The first item in a three column, three item row
                    // becomes two wide.
                    row[0].setAttribute("data-tile-x-md", 20);
                }
                // Not enough space, make a new row
                row = [tile];
                rowLength = width;
                rowLarge = Math.max(0, rowLarge - 1);
            }

            // If our last row was three tiles, tweak the first in that row
            if (row.length === 3) {
                // The first item in a three column, three item row
                // becomes two wide.
                row[0].setAttribute("data-tile-x-md", 20);
            }
        }

        var tileResize = function (size) {
            $(".gss-tile").each(function () {
                var el = $(this);
                // Remove current sizing classes, add the one for this particular screen size
                el.removeClass("gss-tile-sized-x10");
                el.removeClass("gss-tile-sized-x20");
                el.removeClass("gss-tile-sized-x30");
                el.addClass("gss-tile-sized-x" + el.data("tile-x-" + size));
            });
        }

        // When in non-desktop modes, add the gss-tile-sized classes.
        // Two columns viewport is 832px wide, Three is 1247px
        enquire.register("screen and (max-width: 831px)", {
            match: function () {
                return tileResize("sm");
            }
        });
        enquire.register("screen and (max-width: 1247px) and (min-width: 832px)", {
            match: function () {
                return tileResize("md");
            }
        });
        enquire.register("screen and (min-width: 1248px)", {
            match: function () {
                return tileResize("default");
            }
        }, true); // Browsers that can't tell us their media queries are always shown as 3 column
    },
    setup: function (logoutUrl, widgetErrorMessage) {
        // <summary>Sets the needed properties for the portal to function.</summary>
        // <param name="lougoutUrl">The logout url.</param>
        GSS.portal.urls.logout = logoutUrl;

        // Set the error message to show in the widget in error status.
        GSS.portal.errorContent.content = widgetErrorMessage;
    },

    stopImpersonating: function (el, e) {
        var _dashboardWidgetId = PortalContainer.getDashboardWidgetId(el);
        var _data = {};

        _data = PortalContainer.setRequiredData(_dashboardWidgetId, _data);
        $.ajax({ type: 'POST', url: '../_Account/StopImpersonating', data: jQuery.param(_data), cache: false })
            .done(function (data) {
                if (data) {
                    $('body').append(data);
                }
            });
    },

    setDefaultLanguage: function (e) {
        var _data = { isoCode: e.currentTarget.getAttribute('gss-data-language-selection-dropdown') };
        var _url;
        if (e.currentTarget.getAttribute('gss-data-from-landing')) {
            _url = window.location + '/_Home/SetLanguage';
        }
        else {
            _url = '../_Home/SetLanguage'
        }

        $.ajax({ type: 'POST', url: _url, data: jQuery.param(_data), cache: false })
            .done(function (data) {
                if (data.isRedirect) {
                    window.location.href = data.redirectUrl;
                }
                else {
                    location.reload();
                }
            });
    },

    configProgress: function (options) {
        var _defaults = {
            delay: 500,
            duration: 3000,
            message: 'Please wait while your data is loaded.',
            anchor: '#wrap',
        };
        var _options = $.extend({}, _defaults, options);

        $(document).ready(function () {
            var _$container = $(_options.anchor);
            if (_$container.length > 0) {
                _$container.data('message', _options.message);
                _$container.data('delay', _options.delay);
                _$container.data('duration', _options.duration);
            }
        });
    },

    setPageTitle: function (title) {
        if (title) {
            document.title = title + " " + GSS.PageTitlePrefix;
        }
    },
}

// Dynamic event binding
$(document).on('click', 'li[gss-data-language-selection-dropdown]', GSS.portal.setDefaultLanguage);

$(document).ready(function () {
  
    const currentUrl = $('a#navbarbrand').attr('href');
    if (currentUrl) {

        const urlToUse = sessionStorage.getItem('homeUrl');
        if (urlToUse) {
            // get the query string of current url and query the url params.
            const queryString = currentUrl.split('?')[1] || '';
            const queryUrlParams = new URLSearchParams(queryString ? decodeURIComponent(queryString) : '');

            // If there is a valid URL to use, and if the current url is empty with no client id parameter then use the session stored url.
            if (!queryUrlParams.get('gssClientId')) {
                $('#navbarbrand').attr('href', urlToUse);
            }
        }
    }

    var signOutOption = $("#signOut");
    if (signOutOption.val()) {
        GSS.portal.idleMonitor.initialize();
    }
    $('.c-sidenav__link').each(function () { $('.c-sidenav__link').attr('tabindex', -1); });
});

// help text popover binding
$(document).popover({
    selector: '[data-help-icon="popover"]',
    container: 'body',
    trigger: 'focus',
    html: true
});
//Check if Side Menu expanded on Language DropDown
$(document).on('click', 'a[data-language-anchor=""]', function (e) { if ($('#btc-sidenav').attr('aria-expanded') === 'true') { sideNavTabSelection(true); } });
//Check if Side Menu expanded UerClient DropDown
$(document).on('click', 'a[data-userclient-anchor=""]', function (e) { if ($('#btc-sidenav').attr('aria-expanded') === 'true') { sideNavTabSelection(true); } });
//Check if Side Menu expanded on CartNav
$(document).on('click', 'a[data-gss-name="cartNav"]', function (e) { if ($('#btc-sidenav').attr('aria-expanded') === 'true') { sideNavTabSelection(true); } });
//Check if Side Menu expanded on User Login DropDown
$(document).on('click', 'a[data-userlogin-anchor=""]', function (e) { if ($('#btc-sidenav').attr('aria-expanded') === 'true') { sideNavTabSelection(true); } });
function closeSideNav() {
    sideNavTabSelection(true);
    $('#btc-sidenav').removeClass('c-sidenav__toggle hidden-mobile-nav');
    $('#btc-sidenav').addClass('c-sidenav__toggle hidden-mobile-nav collapsed');
    $('#btc-sidenav').attr('aria-expanded', 'false');
    $('#c-sidenav').removeClass('c-sidenav visible-desktop-nav collapse in');
    $('#c-sidenav').addClass('c-sidenav visible-desktop-nav collapse');
    $('#c-sidenav').attr('aria-expanded', 'false');
    $('#c-sidenav').attr('aria-expanded', 'false');
}
//Click event setting the Tabindexing for the Side Nav Menu
$(document).on('click', 'button[data-nav-button=""]', function (e) {
    if ($('#btc-sidenav').attr('aria-expanded') === 'true') { sideNavTabSelection(false); }
    else { sideNavTabSelection(true); }
});
// fuction that sets the tabindex
function sideNavTabSelection(isOpen) {
    if (isOpen) {
        $("#navbarbrand").removeAttr('tabindex');
        $('a[data-gss-name="cartNav"]').removeAttr('tabindex');
        $('a[data-gss-name="bellNotificationNav"]').removeAttr('tabindex');
        $('a[data-userlogin-anchor=""]').each(function () { $('a[data-userlogin-anchor=""]').removeAttr('tabindex'); });
        $('a[data-language-anchor=""]').each(function () { $('a[data-language-anchor=""]').removeAttr('tabindex'); });
        $('a[data-userclient-anchor=""]').each(function () { $('a[data-userclient-anchor=""]').removeAttr('tabindex'); });
        $('.c-sidenav__link').each(function () { $('.c-sidenav__link').attr('tabindex', -1); });
    }
    else {
        $('a[data-language-anchor=""]').each(function () { $('a[data-language-anchor=""]').attr('tabindex', -1); });
        $('a[data-userclient-anchor=""]').each(function () { $('a[data-userclient-anchor=""]').attr('tabindex', -1); });
        $('a[data-userlogin-anchor=""]').each(function () { $('a[data-userlogin-anchor=""]').attr('tabindex', -1); });
        $("#navbarbrand").attr('tabindex', -1);
        $('a[data-gss-name="cartNav"]').attr('tabindex', -1);
        $('a[data-gss-name="bellNotificationNav"]').attr('tabindex', -1);
        $('#c-sidenav').closest('a').trigger('focus');
        $('.c-sidenav__link').each(function () { $('.c-sidenav__link').attr('tabindex', 0); });
    }
}
//Check Keyup event for Excape,Enter Space bar and TAb
$(document).on('keyup', function (e) {

    //escape key and if focus is on side nav button or side mav menu
    if (e.keyCode == 27 || e.which === 27) {
        //If focus is on the nav menu
        if (($('#btc-sidenav').attr('aria-expanded') === 'true') && $('#c-sidenav').is(':focus')) { closeSideNav(); $('#btc-sidenav').trigger('focus'); }
        //If focus is on an anchor in the nav menu
        else if (($('#btc-sidenav').attr('aria-expanded') === 'true') && $('.c-sidenav__link').is(':focus')) { closeSideNav(); $('#btc-sidenav').trigger('focus'); }
        else { if ($('#btc-sidenav').attr('aria-expanded') === 'true') { closeSideNav(); } }
    }
    //enter key
    if (e.keyCode === 13 || e.which === 13) { if ($('#btc-sidenav').attr('aria-expanded') === 'false' && $('#btc-sidenav').is(':focus')) { sideNavTabSelection(false); } }
    //space bar
    if (e.keyCode === 32 || e.which === 32) { if ($('#btc-sidenav').attr('aria-expanded') === 'false' && $('#btc-sidenav').is(':focus')) { sideNavTabSelection(false); } }
    
});

//Check Keydown event for Tab
$('.c-sidenav').on('keydown', function (e) {
    if (e.keyCode === 9 ) {
        //tabing out of the last anchor
        if ($('.c-sidenav__link').last().is(':focus')) {
            $('#btc-sidenav').trigger('focus');
        }
        
    }
    if (e.which === 9 && e.shiftKey) {
        if ($('#btc-sidenav').is(':focus') && $('#btc-sidenav').attr('aria-expanded') === 'true') {
            $('.c-sidenav__link').last().trigger('focus');
        }
    }
});

/// suppress the side nav tabing when he page is loaded
$(document).on('load', function (e) {
    $('.c-sidenav__link').each(function () { $('.c-sidenav__link').attr('tabindex', -1); });
});
